import './instrument'
import './instrument-posthog'
import * as Sentry from '@sentry/react'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './app/App'
import './index.css'

// Stale-deploy guard: a tab opened before a deploy can lazy-load a route
// chunk whose hash no longer exists on the server. Cloudflare Pages' SPA
// fallback answers with index.html (text/html) and the import throws
// "'text/html' is not a valid JavaScript MIME type". Reload picks up the
// new build; the 10s throttle prevents a reload loop if index.html itself
// is stale (e.g. served from an intermediate cache).
window.addEventListener('vite:preloadError', (event) => {
  const lastReload = Number(sessionStorage.getItem('shelvi_chunk_reload') ?? 0)
  if (Date.now() - lastReload < 10_000) return
  sessionStorage.setItem('shelvi_chunk_reload', String(Date.now()))
  event.preventDefault()
  window.location.reload()
})

createRoot(document.getElementById('root')!, {
  onUncaughtError: Sentry.reactErrorHandler(),
  onCaughtError: Sentry.reactErrorHandler(),
}).render(
  <StrictMode>
    <App />
  </StrictMode>
)
